import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { CALENDLY_CONFIG } from '../config/services.config.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './logo.png';
import hamburger from './hamburger.png';
import Github from './img/github-social.png';
import LinkedIn from './img/linkedin-social.png';
import Behance from './img/behance-social.svg';
import Email from './img/icons/mail.png';
import './App.css';

function TopNav() {
  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname);

  useEffect(() => {
    setActivePath(location.pathname);
  }, [location]);

  const isActive = (path) => activePath === path ? 'active-link' : '';

  // Scroll to top on nav link click
  const handleNavClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="sticky-navbar">
      <nav className="navbar navbar-expand-lg navbar-dark" aria-label="Main navigation">
        <div className="div">
          <Link to="/" onClick={handleNavClick} aria-label="Home">
            <img className="mx-5 my-4" src={logo} style={{ width: 45 }} alt="JMC Design Logo" />
          </Link>
          <button
            className="navbar-toggler mx-4 mt-4 text-light"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation menu"
          >
            <img src={hamburger} alt="" style={{ width: 30, height: 30 }} />
          </button>
        </div>
        <div className="collapse navbar-collapse text-center" id="navbarNav">
          <ul className="navbar-nav" role="list">
            <li className="nav-item">
              <Link 
                to="/about" 
                onClick={handleNavClick} 
                className={`nav-item nav-link mx-3 px-3 top-nav d-flex justify-content-end ${isActive('/about')}`}
                aria-current={isActive('/about') ? 'page' : undefined}
              >
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/Portfolio" 
                onClick={handleNavClick} 
                className={`nav-item nav-link mx-3 px-3 top-nav d-flex justify-content-end ${isActive('/Portfolio')}`}
                aria-current={isActive('/Portfolio') ? 'page' : undefined}
              >
                Portfolio
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link to="/stats" onClick={handleNavClick} className={`nav-item nav-link mx-3 px-3 top-nav d-flex justify-content-end ${isActive('/stats')}`}>Stats</Link>
            </li> */}
            {/* <li className="nav-item">
              <Link to="/blog" onClick={handleNavClick} className={`nav-item nav-link mx-3 px-3 top-nav d-flex justify-content-end ${isActive('/blog')}`}>Blog</Link>
            </li> */}
            {/* <li className="nav-item">
              <Link
                to="/proposal-builder"
                onClick={handleNavClick}
                className={`nav-item nav-link mx-3 px-3 top-nav d-flex justify-content-end ${isActive('/proposal-builder')}`}
              >
                Hire Me
              </Link>
            </li> */}
            <li className="nav-item">
              <Link 
                to="/contact" 
                onClick={handleNavClick} 
                className={`nav-item nav-link mx-3 px-3 top-nav d-flex justify-content-end ${isActive('/contact')}`}
                aria-current={isActive('/contact') ? 'page' : undefined}
              >
                Contact
              </Link>
            </li>
          </ul>
          
          {/* Schedule Call Button - Mobile */}
          <div className="schedule-call-mobile d-lg-none mt-3">
            <a 
              href={CALENDLY_CONFIG.kickoffMeeting} 
              target="_blank" 
              rel="noreferrer" 
              className="btn btn-outline-primary btn-sm"
              style={{fontSize: '0.8rem', padding: '0.25rem 0.75rem'}}
            >
              📅 Schedule Call
            </a>
          </div>
        </div>
          
        {/* Desktop Social Links and Schedule Call */}
        <div className="schedule-call-desktop d-none d-lg-flex justify-content-center align-items-center" style={{ position: 'relative', right: '50px' }}>
          <a className="p-2 social-links" href="mailto:johncrawforddesign@gmail.com"><img src={Email} style={{ width: 25 }} alt="Email" /></a>

          <a className="p-2 social-links" target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/john-michaelcrawford"><img src={LinkedIn} style={{ width: 25 }} alt="LinkedIn Profile" /></a>

          <a className="p-2 social-links" target="_blank" rel="noreferrer" href="https://github.com/JMC818386"><img src={Github} style={{ width: 25 }} alt="GitHub Profile" /></a>

          <a className="p-2 social-links" target="_blank" rel="noreferrer" href="https://www.behance.net/johncrawforddesign"><img src={Behance} style={{ width: 25, filter: 'grayscale(100%) brightness(0.8)' }} alt="Behance Profile" /></a>
          
          {/* Calendly Schedule Call Button */}
          <a 
            href={CALENDLY_CONFIG.kickoffMeeting} 
            target="_blank" 
            rel="noreferrer" 
            className="btn btn-outline-primary btn-sm ms-3"
            style={{fontSize: '0.8rem', padding: '0.25rem 0.75rem'}}
          >
            📅 Schedule Call
          </a>
        </div>
      </nav>
    </div>
  );
}

export default TopNav;
